import { ServiceBase } from '../../../../../core/services/ServiceBase'
import ScoreCompanyProxy from './proxy'

class ScoreCompanyService extends ServiceBase {
  getRiskScaleInterpretation(params) {
    return this.getData(() =>
      ScoreCompanyProxy.getRiskScaleInterpretation(params),
    )
  }

  getHistoricalChangeDrdData(params) {
    return this.getData(() =>
      ScoreCompanyProxy.getHistoricalChangeDrdData(params),
    )
  }

  getHistoricalChange(params) {
    return this.getData(() => ScoreCompanyProxy.getHistoricalChange(params))
  }

  downloadHistoricalChange(params) {
    return this.getFileDownload(() =>
      ScoreCompanyProxy.downloadHistoricalChange(params),
    )
  }

  getPDTermStructure(params) {
    return this.getData(() => ScoreCompanyProxy.getPDTermStructure(params))
  }

  getCommentary(params) {
    return this.getData(() => ScoreCompanyProxy.getCommentary(params))
  }

  getLinkageScore(params) {
    return this.getData(() => ScoreCompanyProxy.getLinkageScore(params))
  }

  downloadLinkageScore(params) {
    return this.getFileDownload(() =>
      ScoreCompanyProxy.downloadLinkageScore(params),
    )
  }

  getDistributionScore(params) {
    return this.getData(() => ScoreCompanyProxy.getDistributionScore(params))
  }

  downloadDistributionScore(params) {
    return this.getFileDownload(() =>
      ScoreCompanyProxy.downloadDistributionScore(params),
    )
  }

  getBreakdown(params) {
    return this.getData(() => ScoreCompanyProxy.getBreakdown(params))
  }

  getBreakdownCompare(params) {
    return this.getData(() => ScoreCompanyProxy.getBreakdownCompare(params))
  }

  getRiskDriverData(params) {
    return this.getData(() => ScoreCompanyProxy.getRiskDriverData(params))
  }

  downloadRiskDriverData(params) {
    return this.getFileDownload(() =>
      ScoreCompanyProxy.downloadRiskDriverData(params),
    )
  }

  getRiskDriverCompare(params) {
    return this.getData(() => ScoreCompanyProxy.getRiskDriverCompare(params))
  }

  downloadRiskDriverCompareData(params) {
    return this.getFileDownload(() =>
      ScoreCompanyProxy.downloadRiskDriverCompareData(params),
    )
  }
}

export default new ScoreCompanyService()
